'use client'
import React from 'react'
import CTHeaderContainer from '../variants/cleartrip'
import FlyinHeaderContainer from '../variants/flyin'
import { useIsHeya } from '@/src/hooks/useThemeKey'
import { VARIANT } from '@/src/utils/buildUtils'
import { featureConfig } from '@/src/utils/featureConfig'

interface HeaderContainerProps {
    hideSignIn?: boolean
    domainCountry?: string
    showVisa?: boolean
    /** Omit to fall back to the Heya-aware default below — most callers other than
     * ResponsiveHeader (which also knows the AE-domain state) don't pass this explicitly. */
    showFlightsHotels?: boolean
    /** Active vertical resolved server-side (from the request path) for nav highlighting. */
    activeVertical?: string | null
}

const HeaderContainer: React.FC<HeaderContainerProps> = ({
    hideSignIn = false,
    domainCountry,
    showVisa = false,
    showFlightsHotels,
    activeVertical = null
}) => {
    const isHeya = useIsHeya()
    const { FLIGHTS_HOTELS } = featureConfig[VARIANT] || {}
    const resolvedShowFlightsHotels = showFlightsHotels ?? (!!FLIGHTS_HOTELS && !isHeya)
    const showFlyinHeader = domainCountry === 'FEG' || domainCountry === 'FSA' || domainCountry === 'FAE'

    return showFlyinHeader ? (
        <FlyinHeaderContainer
            hideSignIn={hideSignIn}
            showVisa={showVisa}
            showFlightsHotels={resolvedShowFlightsHotels}
            activeVertical={activeVertical}
        />
    ) : (
        <CTHeaderContainer hideSignIn={hideSignIn} showVisa={showVisa} activeVertical={activeVertical} />
    )
}

export { HeaderContainer }
export default HeaderContainer
